/**
 * @hidden
 */
export var FileShareContentType;
(function (FileShareContentType) {
    FileShareContentType["TEXT"] = "text/*";
    FileShareContentType["TEXT_PLAIN"] = "text/plain";
    FileShareContentType["TEXT_RTF"] = "text/rtf";
    FileShareContentType["TEXT_HTML"] = "text/html";
    FileShareContentType["TEXT_JSON"] = "text/json";
    FileShareContentType["IMAGE"] = "image/*";
    FileShareContentType["IMAGE_JPG"] = "image/jpg";
    FileShareContentType["IMAGE_PNG"] = "image/png";
    FileShareContentType["IMAGE_GIF"] = "image/gif";
    FileShareContentType["PDF"] = "application/pdf";
})(FileShareContentType || (FileShareContentType = {}));
//# sourceMappingURL=definitions.js.map